import cx from 'classnames';
import { Icon } from '@components/icon/Icon';
import typography from '~styles/typography.scss';
import styles from './StaffNoteShow.scss';

export interface StaffNoteShowFormProps {
  note: string | null;
  onEdit: () => void;
  className?: string;
}

export const StaffNoteShow = ({
  onEdit,
  note,
  className,
}: StaffNoteShowFormProps) => (
  <section
    aria-labelledby="staff-note-heading"
    className={cx(styles.showForm, className)}
  >
    <header>
      <h3 id="staff-note-heading" className={typography.h7}>
        <Icon name="file" /> Visit Notes
      </h3>
      <button onClick={onEdit}>
        <Icon name="pencil" />
        <span className={typography.t3}>Edit</span>
      </button>
    </header>
    <p className={typography.t1}>{note || 'Add Visit Notes'}</p>
  </section>
);
